import request from '@/utils/request'

/**
 * 添加公告
 * POST /api/v1/admin/content_management/announcement/add
 *
 * @param {Object} data
 * @param {number} [data.activity_id] 活动 ID
 * @param {string} data.content 公告内容
 * @param {number} data.disable_at 失效时间时间戳
 * @param {number} data.enable_at 生效时间时间戳
 * @param {number} data.jump_type 跳转类型
 * @param {number} data.link_type 链接类型
 * @param {string} data.link_url 链接地址
 * @param {number} data.open_type 打开方式
 * @param {string} data.title 公告标题
 * @param {number} data.type 公告类型
 */
export function addAnnouncement(data) {
  return request({
    url: '/api/v1/admin/content_management/announcement/add',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 删除公告
 * POST /api/v1/admin/content_management/announcement/delete
 *
 * @param {Object} data
 * @param {number} data.id 公告 ID
 * @param {number} data.status 状态 1=启用 2=停用
 */
export function deleteAnnouncement(data) {
  return request({
    url: '/api/v1/admin/content_management/announcement/delete',
    method: 'post',
    mock: false,
    data,
  })
}
///api/v1/admin/content_management/announcement/update_status // 更新公告状态
export function updateAnnouncementStatus(data) {
  return request({
    url: '/api/v1/admin/content_management/announcement/update_status',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 公告列表
 * POST /api/v1/admin/content_management/announcement/list
 *
 * @param {Object} data
 * @param {number} [data.end_at] 结束时间
 * @param {number} data.page 当前页
 * @param {number} data.page_size 每页条数
 * @param {number} [data.start_at] 开始时间
 * @param {number} [data.status] 状态
 * @param {string} [data.title] 标题搜索
 * @param {number} [data.type] 公告类型
 */
export function getAnnouncementList(data) {
  return request({
    url: '/api/v1/admin/content_management/announcement/list',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 设置特殊公告 VIP 等级限制
 * POST /api/v1/admin/content_management/announcement/special_limit
 *
 * @param {Object} data
 * @param {number[]} data.vip_limit 限制的 VIP 等级列表
 */
export function setAnnouncementSpecialLimit(data) {
  return request({
    url: '/api/v1/admin/content_management/announcement/special_limit/update',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 获取特殊公告 VIP 等级限制
 * POST /api/v1/admin/content_management/announcement/special_limit/get
 *
 * 无请求体
 */
export function getAnnouncementSpecialLimit() {
  return request({
    url: '/api/v1/admin/content_management/announcement/special_limit/get',
    method: 'post',
    mock: false,
  })
}

/**
 * 更新公告
 * POST /api/v1/admin/content_management/announcement/update
 *
 * @param {Object} data
 * @param {number} data.id 公告 ID
 * @param {number} [data.activity_id] 活动 ID
 * @param {string} [data.content] 公告内容
 * @param {number} [data.disable_at] 失效时间时间戳
 * @param {number} [data.enable_at] 生效时间时间戳
 * @param {number} [data.jump_type] 跳转类型
 * @param {number} [data.link_type] 链接类型
 * @param {string} [data.link_url] 链接地址
 * @param {number} [data.open_type] 打开方式
 * @param {string} [data.title] 公告标题
 * @param {number} [data.type] 公告类型
 */
export function updateAnnouncement(data) {
  return request({
    url: '/api/v1/admin/content_management/announcement/update',
    method: 'post',
    mock: false,
    data,
  })
}
